// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Sentry = require("./Sentry.bs.js");
let Scalars = require("../scalars/Scalars.bs.js");
let TanDate = require("./common/types/TanDate.bs.js");
let ReasonPromise = require("./ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let EventLogs_RecordEventV5Mutation_graphql = require("../__generated__/EventLogs_RecordEventV5Mutation_graphql.bs.js");
let EventLogs_RecordEventForLoggedInUserMutation_graphql = require("../__generated__/EventLogs_RecordEventForLoggedInUserMutation_graphql.bs.js");

function toString(x) {
  switch (x) {
    case "Logout" :
      return "logout";
    case "Login" :
      return "login";
    case "DuplicateAddressWarning" :
      return "duplicate_address_warning";
    case "SubscriptionsReconnected" :
      return "subscriptions_reconnected";
    case "ClientHomePageAreaSearch" :
      return "client_home_page_area_search";
    case "ClientHomePagePropertySearch" :
      return "client_home_property_search";
    case "EmailActivityViewProfile" :
      return "email_activity_view_profile";
  }
}

let EventKey = {
  toString: toString
};

let convertVariables = EventLogs_RecordEventV5Mutation_graphql.Internal.convertVariables;

let convertResponse = EventLogs_RecordEventV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = EventLogs_RecordEventV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, EventLogs_RecordEventV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, EventLogs_RecordEventV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let RecordEventV5Mutation_actorTypeV5_decode = EventLogs_RecordEventV5Mutation_graphql.Utils.actorTypeV5_decode;

let RecordEventV5Mutation_actorTypeV5_fromString = EventLogs_RecordEventV5Mutation_graphql.Utils.actorTypeV5_fromString;

let RecordEventV5Mutation = {
  actorTypeV5_decode: RecordEventV5Mutation_actorTypeV5_decode,
  actorTypeV5_fromString: RecordEventV5Mutation_actorTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let convertVariables$1 = EventLogs_RecordEventForLoggedInUserMutation_graphql.Internal.convertVariables;

let convertResponse$1 = EventLogs_RecordEventForLoggedInUserMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = EventLogs_RecordEventForLoggedInUserMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, EventLogs_RecordEventForLoggedInUserMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, EventLogs_RecordEventForLoggedInUserMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let RecordEventForLoggedInUserMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$1
};

function useRecordEvent() {
  let match = use();
  let mutate = match[0];
  return (actor, data, key, param) => {
    let match = ReasonPromise.pending();
    let resolve = match[1];
    mutate({
      input: {
        actor: {
          actorId: actor[1],
          actorType: actor[0]
        },
        event: {
          data: Stdlib_Option.map(data, d => d),
          key: toString(key),
          occurredAt: Scalars.DateTime.fromJsDate(TanDate.now())
        }
      }
    }, undefined, undefined, undefined, (param, param$1) => resolve(), e => {
      Sentry.captureException(new Error(e.message), "EventLogs.res", 71, {
        exn: e
      }, undefined);
      resolve();
    }, undefined);
    return match[0];
  };
}

function useRecordEventByCurrentUser() {
  let match = use$1();
  let mutate = match[0];
  return (data, key, param) => {
    let match = ReasonPromise.pending();
    let resolve = match[1];
    mutate({
      input: {
        event: {
          data: Stdlib_Option.map(data, d => d),
          key: toString(key),
          occurredAt: Scalars.DateTime.fromJsDate(TanDate.now())
        }
      }
    }, undefined, undefined, undefined, (param, param$1) => resolve(), e => {
      Sentry.captureException(new Error(e.message), "EventLogs.res", 108, {
        exn: e
      }, undefined);
      resolve();
    }, undefined);
    return match[0];
  };
}

exports.EventKey = EventKey;
exports.RecordEventV5Mutation = RecordEventV5Mutation;
exports.RecordEventForLoggedInUserMutation = RecordEventForLoggedInUserMutation;
exports.useRecordEvent = useRecordEvent;
exports.useRecordEventByCurrentUser = useRecordEventByCurrentUser;
/* commitMutation Not a pure module */
